export const SPOTLIGHT_ONBOARDING_STEP1_TARGET = 'rovo-chat-button';
export const SPOTLIGHT_ONBOARDING_STEP2_TARGET = 'rovo-chat-convo-starters';
export const SPOTLIGHT_ONBOARDING_STEP3_TARGET = 'rovo-agents-selector';
